import React from 'react';

function Features() {
    return (
        <div className="rn-service-area rn-section-gap section-separator" id="features">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title text-left" data-aos="fade-up" data-aos-duration="500" data-aos-delay="100" data-aos-once="true">
                            <span className="subtitle">Features</span>
                            <h2 className="title">What I Do</h2>
                        </div>
                    </div>
                </div>
                <div className="row row--25 mt_md--10 mt_sm--10">
                    <div data-aos="fade-up" data-aos-duration="500" data-aos-delay="100" data-aos-once="true" className="col-lg-6 col-xl-4 col-md-6 col-sm-12 col-12 mt--50 mt_md--30 mt_sm--30">
                        <div className="rn-service">
                            <div className="inner">
                                <div className="icon">
                                    <i data-feather="menu" />
                                </div>
                                <div className="content">
                                    <h4 className="title">
                                        <a href="#">Full Stack Development</a>
                                    </h4>
                                    <p className="description">
                                        Specializing in end-to-end web development using Python, Django, and React.js. Creating robust, scalable solutions for complex business workflows and high-volume systems.
                                    </p>
                                    <a className="read-more-button" href="#"><i className="feather-arrow-right" /></a>
                                </div>
                            </div>
                            <a className="over-link" href="#" />
                        </div>
                    </div>

                    <div data-aos="fade-up" data-aos-duration="500" data-aos-delay="300" data-aos-once="true" className="col-lg-6 col-xl-4 col-md-6 col-sm-12 col-12 mt--50 mt_md--30 mt_sm--30">
                        <div className="rn-service">
                            <div className="inner">
                                <div className="icon">
                                    <i data-feather="book-open" />
                                </div>
                                <div className="content">
                                    <h4 className="title">
                                        <a href="#">Database Design & Optimization</a>
                                    </h4>
                                    <p className="description">
                                        Designing efficient schemas for PostgreSQL and MySQL. Writing optimized queries and managing data integrity for applications handling millions in transactions.
                                    </p>
                                    <a className="read-more-button" href="#"><i className="feather-arrow-right" /></a>
                                </div>
                            </div>
                            <a className="over-link" href="#" />
                        </div>
                    </div>

                    <div data-aos="fade-up" data-aos-duration="500" data-aos-delay="500" data-aos-once="true" className="col-lg-6 col-xl-4 col-md-6 col-sm-12 col-12 mt--50 mt_md--30 mt_sm--30">
                        <div className="rn-service">
                            <div className="inner">
                                <div className="icon">
                                    <i data-feather="tv" />
                                </div>
                                <div className="content">
                                    <h4 className="title">
                                        <a href="#">Cloud Deployment & DevOps</a>
                                    </h4>
                                    <p className="description">
                                        Deploying and managing applications on AWS (EC2, RDS, S3). Configuring Nginx, Gunicorn, and Docker for high-performance and scalable production environments.
                                    </p>
                                    <a className="read-more-button" href="#"><i className="feather-arrow-right" /></a>
                                </div>
                            </div>
                            <a className="over-link" href="#" />
                        </div>
                    </div>

                    <div data-aos="fade-up" data-aos-duration="500" data-aos-delay="100" data-aos-once="true" className="col-lg-6 col-xl-4 col-md-6 col-sm-12 col-12 mt--50 mt_md--30 mt_sm--30">
                        <div className="rn-service">
                            <div className="inner">
                                <div className="icon">
                                    <i data-feather="twitch" />
                                </div>
                                <div className="content">
                                    <h4 className="title">
                                        <a href="#">REST API Development</a>
                                    </h4>
                                    <p className="description">
                                        Architecting secure and well-documented RESTful APIs using Django REST Framework to power web and mobile applications with complex authentication requirements.
                                    </p>
                                    <a className="read-more-button" href="#"><i className="feather-arrow-right" /></a>
                                </div>
                            </div>
                            <a className="over-link" href="#" />
                        </div>
                    </div>

                    <div data-aos="fade-up" data-aos-duration="500" data-aos-delay="300" data-aos-once="true" className="col-lg-6 col-xl-4 col-md-6 col-sm-12 col-12 mt--50 mt_md--30 mt_sm--30">
                        <div className="rn-service">
                            <div className="inner">
                                <div className="icon">
                                    <i data-feather="wifi" />
                                </div>
                                <div className="content">
                                    <h4 className="title">
                                        <a href="#">Payment Systems</a>
                                    </h4>
                                    <p className="description">
                                        Implementing secure payment gateway integrations (Stripe, etc.) and building transaction processing workflows for loyalty, voucher, and e-commerce platforms.
                                    </p>
                                    <a className="read-more-button" href="#"><i className="feather-arrow-right" /></a>
                                </div>
                            </div>
                            <a className="over-link" href="#" />
                        </div>
                    </div>

                    <div data-aos="fade-up" data-aos-duration="500" data-aos-delay="500" data-aos-once="true" className="col-lg-6 col-xl-4 col-md-6 col-sm-12 col-12 mt--50 mt_md--30 mt_sm--30">
                        <div className="rn-service">
                            <div className="inner">
                                <div className="icon">
                                    <i data-feather="slack" />
                                </div>
                                <div className="content">
                                    <h4 className="title">
                                        <a href="#">System Architecture</a>
                                    </h4>
                                    <p className="description">
                                        Making critical decisions on technology stacks and architectural patterns. Designing systems using Celery and Redis for asynchronous operations and performance.
                                    </p>
                                    <a className="read-more-button" href="#"><i className="feather-arrow-right" /></a>
                                </div>
                            </div>
                            <a className="over-link" href="#" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Features;
